import { BrandshopTrackPromotionEvent } from '@/common/analytics/gtm/Homepage/brandshopsAnalytics';
import { trackG4ViewPromotion } from '@/common/analytics/gtm/shared/trackViewPromotion';
import { ImpressionsContextProvider } from '@/common/impressions';
import BrandshopsView from '@/modules/HomePage/components/Brandshops/BrandshopsView';
import useHomepageContext from '@/modules/HomePage/HomePageContext';

const Brandshops = () => {
  const { brandsFeed } = useHomepageContext();

  if (!brandsFeed || brandsFeed.length === 0) return null;

  return (
    <ImpressionsContextProvider<BrandshopTrackPromotionEvent>
      callback={trackG4ViewPromotion}
      shouldSendSeparately
    >
      <BrandshopsView brands={brandsFeed} />
    </ImpressionsContextProvider>
  );
};

export default Brandshops;
